module.exports = __webpack_public_path__ + "static/05-0190aa4b6f6a2634fd98273825bf9efc.png";